// ============================================================
// ReactionDosChart - a reaction's DoS distribution bar chart.
// Fail bar in red, success bars in the reaction's colour.
// ============================================================
import BarChart from './BarChart';
import type { ReactionProbability } from '../../engine/defenceProbability';

export default function ReactionDosChart({ data, colour }: { data: ReactionProbability; colour: string }) {
  const bars = data.dosDistribution.map((p, i) => ({
    label: i === 0 ? 'Fail' : `${i - 1} DoS`,
    value: p,
    color: i === 0 ? '#ef4444' : colour,
  }));
  return (
    <BarChart data={bars} barColor={colour} showValues formatValue={(v) => (v * 100).toFixed(0) + '%'} maxValue={1} />
  );
}
